function footerUIInit(trackOrderStatusURL) {
  dojo.query("#orderstatus").forEach(function(node){
    if(isGuest){
      var urlVal = '/webapp/wcs/stores/servlet/PetcoGuestOrderLookupView?storeId='+WCParamJS.storeId;
      dojo.setAttr(node, "href", urlVal);
    }else {
     	dojo.setAttr(node, "href", trackOrderStatusURL);
    }
  });
}

dojo.addOnLoad(function(){ 
	requestSubmitted = false;
	dojo.query('div[dojoType]').forEach(function(node, index, arr){
		addToWidgetsList(node.id);
	});
	parseAllWidgets();
}); 	
$( document ).ready(function() {
	if(window.pagetype == 'undefined' || !window.pagetype=='home'){
		requestSubmitted = false;
		petcoLocation.populateCity();	
		dojo.topic.subscribe("cookieAddedForPhysicalStoreId", function(){petcoLocation.populateCity();});
	}

	});